export var AlignPoint;
(function (AlignPoint) {
    AlignPoint["bottom"] = "bottom";
    AlignPoint["center"] = "center";
    AlignPoint["middle"] = "middle";
    AlignPoint["left"] = "left";
    AlignPoint["right"] = "right";
    AlignPoint["top"] = "top";
})(AlignPoint || (AlignPoint = {}));
